/**
 * Service/Ch (Cohesity) Controller
 *
 * Displays information about Cohesity orders
 */

// the constructor for this object
function ServiceChController() { }

// the object
ServiceChController.prototype = {
    constructor: ServiceChController,
    
    // the base order id
    baseOrderId: false,
    
    // store the Backup Objects chart object here
    backupMgmtVmChart: false,
    
    // store the Backup Storage stats chart object here
    backupStorageChart: false,
    
    // store the Replication Storagestats chart object here
    repStorageChart: false,
                
    // the number of order per page
    perPage: 10,
    
    // the last data submitted to the API, used to prevent multiple api requests
    lastBmVmSubmittedData: {},
    
    // if this order has backed up objects
    hasBackupVms: false,

    // if this order has backup storage
    hasBackupStorage: false,

    // if this order has replication storage
    hasRepStorage: false,
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        // register the route variables used by this controller
        this._registerRouteVariables();
                
        // register charts 
        this._registerCharts();
        
        PortalHelper.debugMessage('Service Cohesity Initialized');
    },
    
    // run the controller
    run: function()
    {        
        // get and populate the order
        this._getOrder();
        
        // get/populate the Cohesity specific order info
        this._getChOrder();
        
        // register the events used by this controller
        this._registerEvents();
        
        PortalHelper.debugMessage('Service Cohesity Controller Ran');
    },
    
    // get the route variables and include them in the controller
    _registerRouteVariables: function() 
    {
        var segments = PortalMain.getRouteSegments();
        
        // set the base order id
        if (segments.length == 1) {
            this.baseOrderId = segments[0];
        } else {
            // the uri is missing important pieces
            PortalHelper.sendToDashboard();
        }
    },

    // register the javascript events
    _registerEvents:  function() 
    {   
        // bind to any of the dropdown links
        PortalHelper.hideDropdownOnClick('#range-selection-dropdown');
        $('#range-selection-dropdown ul li a').on('click', function(){
            PortalMain.ServiceChController._updateChartRange(
                this.dataset.timelineRangeSeconds
            );
            
            PortalMain.ServiceChController._updateSelectedRange(this);
        });
    },
    
    // register the chart
    _registerCharts: function()
    {
        // new chart for backup management vms
        var backupMgmtVmChart = new PortalChart;
        backupMgmtVmChart.elementId = 'bm-obj-chart';
        backupMgmtVmChart.type = 'line';
        backupMgmtVmChart.dataFormat = 'number';
        backupMgmtVmChart.columns = [];
        this.backupMgmtVmChart = backupMgmtVmChart;
        
        // new chart for backup storage
        var backupStorageChart = new PortalChart;
        backupStorageChart.elementId = 'bs-chart';
        backupStorageChart.type = 'line';
        backupStorageChart.dataFormat = 'bytes';
        backupStorageChart.columns = [];
        this.backupStorageChart = backupStorageChart;
        
        // new chart for replication storage
        var repStorageChart = new PortalChart;
        repStorageChart.elementId = 'rep-chart';
        repStorageChart.type = 'line';
        repStorageChart.dataFormat = 'bytes';
        repStorageChart.columns = [];
        this.repStorageChart = repStorageChart;
        
    },
    
    // get the orders from the api
    _getOrder: function()
    {
        PortalMain.ServiceIndexController = new ServiceIndexController;
        
        PortalMain.ServiceIndexController.baseOrderId = this.baseOrderId;
        
        PortalMain.ServiceIndexController._getOrder();
    },
    
    // get ChaaS specific order info (usage information)
    _getChOrder: function()
    {
        var chOrderRequest = new PortalRequest;
        chOrderRequest.errorElement = '.order-fail';
        chOrderRequest.makeRequest(
            '/orders-ch/get-order-ch',
            {
                baseOrderId: this.baseOrderId,
            },
            function(data) {
                // set backup mgmt/backup storage/replication storage
                PortalMain.ServiceChController._populateHasBillingComponents(data);
                
                // register tabs based on ch data
                PortalMain.ServiceChController._registerTabs(data);
                
                // get the orders stats
                PortalMain.ServiceChController._getChStats();

                // fill in the stats section
                PortalMain.ServiceChController._populateChOrderStats(data);

                // fill in the rates section
                PortalMain.ServiceChController._populateChOrderRates(data);
                                
            },
            function() {
                // no ch order found, so hide the content
                $('#ch-content').addClass('hidden');
            }
        )
    },
    
    // determine what type of billing components apply
    _populateHasBillingComponents: function(chInfo)
    {
        this.hasBackupVms = chInfo.backup_mgmt_applies;
        this.hasBackupStorage = chInfo.backup_storage_applies;
        this.hasRepStorage = chInfo.replication_storage_applies;
    },
    
    // setup or remove the tabs and
    _registerTabs: function(chInfo)
    {
        if (this.hasBackupVms || this.hasBackupStorage || this.hasRepStorage) {            
            var buttonTabs = new PortalButtonTabs;
            buttonTabs.tabClickCallback = PortalMain.ServiceChController._chartsTabClickCallback;
            buttonTabs.init('.button-tabs');
            $('.button-tabs').removeClass('hidden');
        } else {
            // remove the tab components
            $('.button-tab-target.current').removeClass('current');
            $('.button-tab-target').removeClass('button-tab-target');
            $('.button-tabs').remove();
        }
    },

    // redraw the chart to fill the now visible space
    _chartsTabClickCallback: function(tabTarget)
    {
        if ( tabTarget == 'backup-obj-container' || tabTarget == null){
            $('#backup-obj-container').show();
            $('#backup-storage-container').hide();
            $('#replication-storage-container').hide();
        } else if (tabTarget == 'backup-storage-container') {
            $('#backup-obj-container').hide();
            $('#backup-storage-container').show();
            $('#replication-storage-container').hide();
        } else if (tabTarget == 'replication-storage-container'){
            $('#backup-obj-container').hide();
            $('#backup-storage-container').hide();
            $('#replication-storage-container').show();
        }

        PortalMain.ServiceChController.backupMgmtVmChart.draw();
        PortalMain.ServiceChController.backupStorageChart.draw();
        PortalMain.ServiceChController.repStorageChart.draw();
    },
    
    // populate document with usage information
    // these fill out the boxes above the charts
    _populateChOrderStats: function(chInfo)
    {
        // show the backup vms stats
        if (chInfo.backup_mgmt_applies) {
            // set the vm count
            $('#bm-obj-count').text(chInfo.cohesity.backup_mgmt_objects);
            
            // set the vm mgmt rate
            var vmRate = chInfo.cohesity.backup_mgmt_objects_rate;
            vmRate = PortalHelper.numberToDollars(vmRate, 2, true);
            $('#bm-obj-rate').text(vmRate);
            
            // set the vm mgmt total cost
            var vmTotal = chInfo.cohesity.backup_mgmt_objects_mrc;
            vmTotal = PortalHelper.numberToDollars(vmTotal);
            $('#bm-obj-total').text(vmTotal);
            
            // set the date
            var date = PortalHelper.formatDate(chInfo.cohesity.run_date);
            $('#bm-obj-stats .date').text(date);
            
            PortalHelper.loadingOverlay('#bm-obj-stats', false);
        } else {
            $('#backup-obj-container').remove();
            $('.bm-obj-stats').remove();
        }
        
        // show the backup storage
        if (chInfo.backup_storage_applies) {
            // set the backup storage current
            var bcupStorage = chInfo.cohesity.backup_storage_bytes;
            bcupStorage = PortalHelper.formatBytes(bcupStorage);
            $('#bs-current span:nth-child(1)').text(bcupStorage[0]);
            $('#bs-current span:nth-child(2)').text(bcupStorage[1]);
            
            // set the backup storage rate
            var bcupStorageRate = chInfo.cohesity.backup_storage_rate;
            bcupStorageRate = PortalHelper.numberToDollars(bcupStorageRate, 2, true);
            $('#bs-rate').text(bcupStorageRate);
            
            // set the backup storage total
            var bcupStorageTotal = chInfo.cohesity.backup_storage_mrc;
            bcupStorageTotal = PortalHelper.numberToDollars(bcupStorageTotal);
            $('#bs-total').text(bcupStorageTotal);
            
            // set the date
            var date = PortalHelper.formatDate(chInfo.cohesity.run_date);
            $('#bs-stats .date').text(date);
            
            PortalHelper.loadingOverlay('#bs-stats', false);
        } else {
            $('#backup-storage-container').remove();
            $('#bs-stats').remove();
        }
        
        // replication storage
        if (chInfo.replication_storage_applies) {
            // set the replication storage current
            var repStorage = chInfo.cohesity.replication_storage_bytes;
            repStorage = PortalHelper.formatBytes(repStorage);
            $('#rep-current span:nth-child(1)').text(repStorage[0]);
            $('#rep-current span:nth-child(2)').text(repStorage[1]);
            
            // set the replication storage rate
            var repStorageRate = chInfo.cohesity.replication_storage_rate;
            repStorageRate = PortalHelper.numberToDollars(repStorageRate, 2, true);
            $('#rep-rate').text(repStorageRate);
            
            // set the replication storage total
            var repStorageTotal = chInfo.cohesity.replication_storage_mrc;
            repStorageTotal = PortalHelper.numberToDollars(repStorageTotal);
            $('#rep-total').text(repStorageTotal);
            
            // set the date
            var date = PortalHelper.formatDate(chInfo.cohesity.run_date);
            $('#rep-stats .date').text(date);
            
            PortalHelper.loadingOverlay('#rep-stats', false);
        } else {
            $('#replication-storage-container').remove();
            $('#rep-stats').remove();
        }     
        
    },

    // fill in and display the per GB rate
    _populateChOrderRates: function(chInfo)
    {
        // set the per machine rate
        if (chInfo.cohesity.backup_mgmt_objects != undefined) {
            var perMachineRate = $('#usage-rates .clone-source').clone();
            perMachineRate.removeClass('clone-source');

            $('.rate-label', perMachineRate).text('Per GB Rate');

            var rate = chInfo.cohesity.backup_mgmt_objects_rate;
            rate = PortalHelper.numberToDollars(rate, 2, true);
            $('.rate-amount', perMachineRate).text(rate);

            $('#usage-rates').append(perMachineRate);
        }

        // set the per GB rate
        if (chInfo.cohesity.backup_storage != undefined) {
            var perGbRateBs = $('#usage-rates .clone-source').clone();
            perGbRateBs.removeClass('clone-source');

            $('.rate-label', perGbRateBs).text('Per Obj Rate');

            var rate = chInfo.cohesity.backup_storage_rate;
            rate = PortalHelper.numberToDollars(rate, 2, true);
            $('.rate-amount', perGbRateBs).text(rate);

            $('#usage-rates').append(perGbRateBs);
        }

        // set the per gb rate
        if (chInfo.cohesity.replication_storage != undefined) {
            var perGbRateRep = $('#usage-rates .clone-source').clone();
            perGbRateRep.removeClass('clone-source');

            $('.rate-label', perGbRateRep).text('Per GB Rate');

            var rate = chInfo.cohesity.replication_storage_rate;
            rate = PortalHelper.numberToDollars(rate, 2, true);
            $('.rate-amount', perGbRateRep).text(rate);

            $('#usage-rates').append(perGbRateRep);
        }
    },

    // retrieves the timeline cohesity stats
    _getChStats: function(startDate, endDate)
    {
        // defaulting to 1 week range if a start or end date not passed
        if(!(startDate instanceof Date) || !(endDate instanceof Date)) {
            var startDate = new Date();
            var endDate = new Date();
            
            startDate.setMonth(
                startDate.getMonth() - 1
            );
        }
        
        var chStatsRequest = new PortalRequest;
        chStatsRequest.makeRequest(
            '/orders-ch/get-ch-stats',
            {
                baseOrderId: this.baseOrderId,
                // Date() strikes again. Dividing by 1000 here to get seconds instead of ms
                startDate: startDate.getTime() / 1000|0,
                endDate: endDate.getTime() / 1000|0,
            },
            function(data) {
                PortalMain.ServiceChController._populateBackupVmsChart(data.backup_mgmt, startDate, endDate);
                PortalMain.ServiceChController._populateBackupStorageChart(data.backup_storage, startDate, endDate);
                PortalMain.ServiceChController._populateReplicationStorageChart(data.replication_storage, startDate, endDate);
            }
        );
    },
    
    // sets up the vm count graph, populating columns and data
    _populateBackupVmsChart: function(chartData, startDate, endDate)
    {
        if (this.hasBackupVms) {
            // keep only the specified columns for the chart
            chartData = PortalHelper.chartGetColumns(chartData, [
                'Time',
                'Machine Count',
                'Machine Count Limit'
            ]);
            
            this.backupMgmtVmChart.minDate = startDate;
            this.backupMgmtVmChart.maxDate = endDate;
            // resetting columns first
            this.backupMgmtVmChart.columns = [];
            for(var i in chartData[0]) {
                var currentField = chartData[0][i];
                if(currentField == 'Time') {
                    this.backupMgmtVmChart.columns[i] = ['date', currentField];
                } else {
                    this.backupMgmtVmChart.columns[i] = ['number', currentField];
                }
            }
            
            if(chartData.length == 1) {
                $('#bm-obj-chart').text("No data available for this period.");
            } else {
                this.backupMgmtVmChart.data = chartData;
                this.backupMgmtVmChart.draw();
            }
            PortalHelper.loadingOverlay('#bm-obj-chart', false);   
        }     
    },

    // sets up the backup storage graph, populating columns and data
    _populateBackupStorageChart: function(chartData, startDate, endDate)
    {
        if (this.hasBackupStorage) {
            // keep only the specified columns for the chart
            chartData = PortalHelper.chartGetColumns(chartData, [
                'Time',
                'Aggregate Size',
                'Size Limit'
            ]);
            
            this.backupStorageChart.minDate = startDate;
            this.backupStorageChart.maxDate = endDate;
            // resetting columns first
            this.backupStorageChart.columns = [];
            for(var i in chartData[0]) {
                var currentField = chartData[0][i];
                if(currentField == 'Time') {
                    this.backupStorageChart.columns[i] = ['date', currentField];
                } else {
                    this.backupStorageChart.columns[i] = ['number', currentField];
                }
            }
            
            if(chartData.length == 1) {
                $('#bs-chart').text("No data available for this period.");
            } else {
                this.backupStorageChart.data = chartData;
                this.backupStorageChart.draw();
            }
            PortalHelper.loadingOverlay('#bs-chart', false);   
        }     
    },

    // sets up the replication storage graph, populating columns and data
    _populateReplicationStorageChart: function(chartData, startDate, endDate)
    {
        if (this.hasRepStorage) {
            // keep only the specified columns for the chart
            chartData = PortalHelper.chartGetColumns(chartData, [
                'Time',
                'Aggregate Size',
                'Size Limit'
            ]);
            
            this.repStorageChart.minDate = startDate;
            this.repStorageChart.maxDate = endDate;
            // resetting columns first
            this.repStorageChart.columns = [];
            for(var i in chartData[0]) {
                var currentField = chartData[0][i];
                if(currentField == 'Time') {
                    this.repStorageChart.columns[i] = ['date', currentField];
                } else {
                    this.repStorageChart.columns[i] = ['number', currentField];
                }
            }
            
            if(chartData.length == 1) {
                $('#rep-chart').text("No data available for this period.");
            } else {
                this.repStorageChart.data = chartData;
                this.repStorageChart.draw();
            }
            PortalHelper.loadingOverlay('#rep-chart', false);   
        }     
    },

    // changes what date range is displayed
    _updateChartRange: function(dateRangeSeconds)
    {
        PortalHelper.loadingOverlay('#bm-obj-chart', true);
        PortalHelper.loadingOverlay('#bs-chart', true);
        PortalHelper.loadingOverlay('#rep-chart', true);
        var endDate = new Date();
        var startDate = new Date(
            endDate.getTime() 
            - (dateRangeSeconds * 1000)
        );
        
        this._getChStats(startDate, endDate);
    },
    
    // adds interactivity to the dropdown range selection
    _updateSelectedRange: function(element)
    {
        var selectedElementText = $(element).text();
        $('.selection-text').text(selectedElementText);
    },
    
}